/*************************************************************
 * LoadingSpinner.js - Loading component
 *************************************************************/

export const LoadingSpinner = ({ message = 'Loading...', size = 'normal' }) => {
    const spinnerSize = size === 'large' ? 'spinner-border-lg' : '';

    return (
        <div className="d-flex flex-column align-items-center justify-content-center p-5">
            <div className={`spinner-border text-primary mb-3 ${spinnerSize}`} role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <h5 className="text-muted">{message}</h5>
            <p className="text-muted">Please wait while we process your request</p>
        </div>
    );
};